
// Renders the game background and grid
import { GAME_CONFIG } from '../gameConfig';

// Create the game background
export function createGameBackground(scene) {
  return scene.add.rectangle(
    0, 0, 
    GAME_CONFIG.gameWidth, GAME_CONFIG.gameHeight, 
    GAME_CONFIG.backgroundColor
  ).setOrigin(0);
}

// Draw the game grid
export function drawGrid(scene) {
  const graphics = scene.add.graphics();
  graphics.lineStyle(1, GAME_CONFIG.gridColor, 0.3);
  
  // Draw vertical grid lines
  for (let x = 0; x <= GAME_CONFIG.boardWidth; x++) {
    graphics.beginPath();
    graphics.moveTo(x * GAME_CONFIG.blockSize, 0);
    graphics.lineTo(x * GAME_CONFIG.blockSize, GAME_CONFIG.boardHeight * GAME_CONFIG.blockSize);
    graphics.closePath();
    graphics.strokePath();
  }
  
  // Draw horizontal grid lines
  for (let y = 0; y <= GAME_CONFIG.boardHeight; y++) {
    graphics.beginPath();
    graphics.moveTo(0, y * GAME_CONFIG.blockSize);
    graphics.lineTo(GAME_CONFIG.boardWidth * GAME_CONFIG.blockSize, y * GAME_CONFIG.blockSize);
    graphics.closePath();
    graphics.strokePath();
  }
  
  return graphics;
}
